import { render } from "./gnummodule.vue?vue&type=template&id=796adbf9&scoped=true"
import script from "./gnummodule.vue?vue&type=script&lang=js"
export * from "./gnummodule.vue?vue&type=script&lang=js"

import "./gnummodule.vue?vue&type=style&index=0&id=796adbf9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796adbf9"]])

export default __exports__